import { getComputerMenuQueryKeyPrefix } from '#pplx/frontend/apps/ask/queries/query-keys/computerKeys.js';
import { getPluginDiscoverKey } from '#pplx/frontend/apps/ask/queries/query-keys/pluginKeys.js';
import { getSelectableSkillsKeyPrefix, getSkillsQueryKeyPrefix, } from '#pplx/frontend/apps/ask/queries/query-keys/skillKeys.js';
import { getConnectorMarketplaceSkillsQueryKey, getConnectorMarketplaceSkillsQueryKeyPrefix, getSourcesQueryKeyPrefix, } from '#pplx/frontend/apps/ask/queries/query-keys/sourcesKeys.js';
import { getHomepageUpsellsQueryKey, getSidebarUpsellQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/upsellKeys.js';
import { getUserSettingsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/userKeys.js';
import { logger } from '#pplx/frontend/logger/browser.js';
const INSTALLATION_POLL_INTERVAL_MS = 1000;
const INSTALLATION_POLL_ATTEMPTS = 10;
const wait = (durationMs) => new Promise((resolve) => setTimeout(resolve, durationMs));
async function pollConnectorMarketplaceSkillInstallation(queryClient, sourceId) {
    const queryKey = getConnectorMarketplaceSkillsQueryKey(sourceId);
    for (let attempt = 0; attempt < INSTALLATION_POLL_ATTEMPTS; attempt += 1) {
        const data = queryClient.getQueryData(queryKey);
        const hasPendingInstallation = data?.skills.some((skill) => skill.requires_install && !skill.installed);
        if (!hasPendingInstallation)
            break;
        await wait(INSTALLATION_POLL_INTERVAL_MS);
        await queryClient.refetchQueries({ queryKey, exact: true, type: 'all' });
    }
    await Promise.all([
        queryClient.invalidateQueries({ queryKey: getSkillsQueryKeyPrefix() }),
        queryClient.invalidateQueries({ queryKey: getSelectableSkillsKeyPrefix() }),
        queryClient.invalidateQueries({ queryKey: getPluginDiscoverKey() }),
        queryClient.invalidateQueries({ queryKey: getComputerMenuQueryKeyPrefix() }),
    ]);
}
export async function refreshConnectorAuthQueries(queryClient, connectorSkillsSourceId) {
    await Promise.all([
        queryClient.invalidateQueries({ queryKey: getUserSettingsQueryKey() }),
        queryClient.invalidateQueries({ queryKey: getPluginDiscoverKey() }),
        queryClient.invalidateQueries({ queryKey: getSourcesQueryKeyPrefix() }),
        queryClient.invalidateQueries({ queryKey: getSidebarUpsellQueryKey() }),
        queryClient.invalidateQueries({ queryKey: getHomepageUpsellsQueryKey() }),
    ]);
    // Skill installation runs in the background after the connection is saved.
    // Refresh this state after the connector queries to give that task time to settle.
    await queryClient.invalidateQueries({
        queryKey: getConnectorMarketplaceSkillsQueryKeyPrefix(),
    });
    if (connectorSkillsSourceId) {
        void pollConnectorMarketplaceSkillInstallation(queryClient, connectorSkillsSourceId).catch((error) => {
            logger.error('Failed to refresh connector marketplace skill installation state', error);
        });
    }
}
//# sourceMappingURL=refreshConnectorAuthQueries.js.map